export const TypeVegan = "Vegan";
export const TypeVegetarian = "Vegetarian";
export const TypeOther = "Other";

export enum StoreLocationType {
    VEGAN = "VEGAN",
    VEGETARIAN = "VEGETARIAN",
    OTHER = "OTHER"
}